/**
 * Helper to send data to GTM
 *
 * @param label event label
 * @param d event data...
 */
export const cgtag = (label: string, d: any) => {
  // @ts-ignore
  if (!window.hasOwnProperty('dataLayer')) window['dataLayer'] = [];
  if (d.hasOwnProperty('ecommerce')) {
    // @ts-ignore
    window.dataLayer.push({
      ecommerce: null,
    });
  }
  // @ts-ignore
  window.dataLayer.push({
    event: label,
    ...d,
  });
};
